import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { isDisclosure, logObserver } from '~/functions/helpers';
import { mapQuestionnaireResultsBySectionLabel, questionnaireVersionTextShort } from '~/functions/esg';
import { useGetQuestionnaireForComparisonQuery } from '~/types/types';
export default defineComponent({
  props: {
    first: {
      type: Object,
      required: true
    },
    second: {
      type: Object,
      required: true
    },
    titleFirst: {
      type: String,
      required: false
    },
    titleSecond: {
      type: String,
      required: false
    }
  },
  setup: function setup(props) {
    var firstVersionText = computed(function () {
      var version = questionnaireVersionTextShort(props.first);
      return props.titleFirst ? "".concat(props.titleFirst, ": ").concat(version) : version;
    });
    var secondVersionText = computed(function () {
      var version = questionnaireVersionTextShort(props.second);
      return props.titleSecond ? "".concat(props.titleSecond, ": ").concat(version) : version;
    });
    var _useGetQuestionnaireF = useGetQuestionnaireForComparisonQuery({
        id: props.first.id
      }),
      resultGetFirst = _useGetQuestionnaireF.result,
      refetchFirst = _useGetQuestionnaireF.refetch,
      loadingFirst = _useGetQuestionnaireF.loading;
    var _useGetQuestionnaireF2 = useGetQuestionnaireForComparisonQuery({
        id: props.second.id
      }),
      resultGetSecond = _useGetQuestionnaireF2.result,
      refetchSecond = _useGetQuestionnaireF2.refetch,
      loadingSecond = _useGetQuestionnaireF2.loading;
    watch(function () {
      return [props.first.id, props.second.id];
    }, function (current, _) {
      refetchFirst({
        id: current[0]
      });
      refetchSecond({
        id: current[1]
      });
    });
    var firstQuestionnaireResults = computed(function () {
      var _resultGetFirst$value, _resultGetFirst$value2;
      if (!resultGetFirst.value) return {};
      return mapQuestionnaireResultsBySectionLabel(((_resultGetFirst$value = resultGetFirst.value.getQuestionnaire) === null || _resultGetFirst$value === void 0 ? void 0 : (_resultGetFirst$value2 = _resultGetFirst$value.questionnaireAssignment) === null || _resultGetFirst$value2 === void 0 ? void 0 : _resultGetFirst$value2.questionnaireResults) || []);
    });
    var secondQuestionnaireResults = computed(function () {
      var _resultGetSecond$valu, _resultGetSecond$valu2;
      if (!resultGetSecond.value) return {};
      return mapQuestionnaireResultsBySectionLabel(((_resultGetSecond$valu = resultGetSecond.value.getQuestionnaire) === null || _resultGetSecond$valu === void 0 ? void 0 : (_resultGetSecond$valu2 = _resultGetSecond$valu.questionnaireAssignment) === null || _resultGetSecond$valu2 === void 0 ? void 0 : _resultGetSecond$valu2.questionnaireResults) || []);
    });
    var esgSections = computed(function () {
      var _resultGetFirst$value3, _resultGetFirst$value4, _resultGetFirst$value5, _resultGetFirst$value6;
      return ((_resultGetFirst$value3 = resultGetFirst.value) === null || _resultGetFirst$value3 === void 0 ? void 0 : (_resultGetFirst$value4 = _resultGetFirst$value3.getQuestionnaire) === null || _resultGetFirst$value4 === void 0 ? void 0 : (_resultGetFirst$value5 = _resultGetFirst$value4.questionnaireTemplate) === null || _resultGetFirst$value5 === void 0 ? void 0 : (_resultGetFirst$value6 = _resultGetFirst$value5.sections) === null || _resultGetFirst$value6 === void 0 ? void 0 : _resultGetFirst$value6.filter(function (section) {
        return section && section.id && !isDisclosure(section.id);
      })) || [];
    });
    var isQuestionnaireLogicWithMeasures = computed(function () {
      var _props$first, _props$second;
      var firstIds = ((_props$first = props.first) === null || _props$first === void 0 ? void 0 : _props$first.sections.map(function (section) {
        return section.id;
      })) || [];
      var secondIds = ((_props$second = props.second) === null || _props$second === void 0 ? void 0 : _props$second.sections.map(function (section) {
        return section.id;
      })) || [];
      var sectionIdsForEsgVersion2 = [40, 50, 60, 70];
      var includesAll = function includesAll(ids) {
        return sectionIdsForEsgVersion2.every(function (id) {
          return ids.includes(id);
        });
      };
      return includesAll(firstIds) && includesAll(secondIds);
    });
    return {
      loadingFirst: loadingFirst,
      loadingSecond: loadingSecond,
      esgSections: esgSections,
      firstQuestionnaireResults: firstQuestionnaireResults,
      secondQuestionnaireResults: secondQuestionnaireResults,
      firstVersionText: firstVersionText,
      secondVersionText: secondVersionText,
      isQuestionnaireLogicWithMeasures: isQuestionnaireLogicWithMeasures
    };
  },
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    logObserver: logObserver
  }
});